/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Tooltip } from 'bold-ui'
import { ClassificacaoRiscoEncaminhamentoEnum } from 'graphql/types.generated'
import { useMemo } from 'react'

import { classificacaoRiscoRecord } from '../model-encaminhamentoExterno'

interface StatusClassificacaoRiscoEncaminhamentoProps {
  status: ClassificacaoRiscoEncaminhamentoEnum
  size?: number
  showTooltip?: boolean
}

interface StatusCorDescricao {
  cor: string
  descricao: string
}

export function StatusClassificacaoRiscoEncaminhamento(props: StatusClassificacaoRiscoEncaminhamentoProps) {
  const { status, size = 1, showTooltip = true } = props

  const { mainColor, label } = classificacaoRiscoRecord[status]

  const classes = useMemo(() => createStyles(mainColor, size), [mainColor, size])

  return (
    <Tooltip text={showTooltip && label}>
      <div css={classes.classificacaoRiscoBox} />
    </Tooltip>
  )
}

const createStyles = (cor: string, size: number) => ({
  classificacaoRiscoBox: css`
    width: ${size}rem;
    height: ${size}rem;
    border-radius: 2px;
    background-color: ${cor};
  `,
})
